// Homepage / Main / Re-usable.
export const HOMEPAGE_HEADER_CONTENT = "4bCeTiVIx697HTmeL5sxES";
export const HOMEPAGE_HEADER_IMAGE = "5QqtcbPHUqkzibO37eWGHK";
export const WHY_USE_SAVELY = "27kOImpxHEGFowQJ9l7zRD";
export const FAQS_CONTENT = "8g7bRXb7HgUmv9LL776RL";
export const MOBILE_FAQS = "4OTPPEWBloTXR9dVnUP3wk";
export const TERMS_OF_SERVICE = "7LYpPoeY8SHeSGJqbnA3po";
export const PRIVACY_POLICY = "4LXZRzkRF3xC0qvlb81iFJ";
export const COOKIE_POLICY = "5TVGEYRAezMk2AzTWFftXW";
export const COMPLAINTS_POLICY = "iDt3ZPwxKVMHQqzW2vIUC";
export const ABOUT_US = "3gtYvdWoQ9Ghu3tRSsrb9Y";
export const CONTACT_US = "2ofeA4MB2jOHCqa9MlmWVb";
export const LANDING_PAGE_PROVIDERS = "7LdBUFl71Ai8UgVn8iH0jA";

// Lead Journey
export const LEAD_HEADER_CONTENT = "6uxh75qP5997HALfheENEV";
export const FUNNEL_CURRENT_PROVIDER = "6Pr0PldZw20TtmcwulwvvX";
export const FUNNEL_PREFERRED_SPEEDS = "6A2b1P40bRoAF0wWggTydU";
export const RESULT = "18DMMHzNt8OodF5AHkV34L";
export const DEAL = "4bD9hzt9v91WvfUqmqtEtZ";
export const SUPERFAST_DEAL = "1vmRk6ovSslDrE37pkhRY6";
export const ULTRAFAST_DEAL = "4OuzwmgxQNVkxXrtKhfxtn";
export const GIGAFAST_DEAL = "3U36f2GtCwTMD3AG5LioW9";
export const HOW_IT_WORKS = "6V6JtE9FONbbuxkKnX0fgA";

// Broadband Comparison
export const COMPARISON_HEADER_CONTENT = "2JCkop6vEyAY6E5cJjMlvL";
export const BROADBAND_COMPARISON = "6QJGj4JNbzce2rTM1drB1z";
export const BROADBAND_COMPARISON_FAQS = "3CN4llA00VRLZVMM9wnnYF";
export const FIBRE_BROADBAND_HEADER_CONTENT = "Oj6SFokSvCA2Kgjk3KVeH";
export const WIRELESS_BROADBAND_HEADER_CONTENT = "0YOKUidTDJkutdzbTmksC";
export const BROADBAND_AND_HOME_PHONE_HEADER_CONTENT = "48uoMbQjKxjffu6ZTTEDGj";
export const CHEAP_BROADBAND_HEADER_CONTENT = "5neduAZdubtCNKSZiXeqll";
export const BROADBAND_TV_HEADER_CONTENT = "4qso47f1HoIEI86TvWItvP";
export const BROADBAND_GUIDES_HEADER_CONTENT = "63NyVWVCkRsy4xrRl8pzrM";
export const TWELVE_MONTH_BROADBAND_HEADER_CONTENT = "7euccwGAqX8EAvlOydPIN7";
export const BROADBAND_WITH_GIFTS_HEADER_CONTENT = "72WJKM586ps76O2pZ0f12b";

// Provider Broadband Deals
export const BT_BROADBAND_IMAGE = "6PmnvmwNVuZGBZF2yGWw5X";
export const BT_BROABDBAND_CONTENT = "7oQKvPZqBXqCGHTNI1sjCk";
export const TALKTALK_BROADBAND_IMAGE = "46pxNvDrMd9SaaPy0Ttgyi";
export const TALKTALK_BROADBAND_CONTENT = "3yworvascWt3cMhQCiKqdN";
export const SKY_BROADBAND_IMAGE = "6XmwhkpvhRd6CfDsZbwtaw";
export const SKY_BROADBAND_CONTENT = "3frvuyFJv8k2tRNmSj9IML";
export const PLUSNET_BROADBAND_IMAGE = "6xbecPFsUzf1owyy4k490q";
export const PLUSNET_BROADBAND_CONTENT = "4SQg8Vk2qLpkFvaUXM9Lgf";
export const VIRGIN_MEDIA_BROADBAND_IMAGE = "55PSQCyMsdwA9fJX60fUky";
export const VIRGIN_MEDIA_BROADBAND_CONTENT = "4rB7JV0aMJRSPUZxn2cTec";
export const VODAFONE_BROADBAND_IMAGE = "3JAXVGYxOYPwMGAVDdGtD5";
export const VODAFONE_BROADBAND_CONTENT = "23cbpVUZDEhJighzwXzfvV";
export const EE_BROADBAND_IMAGE = "9nsgeKsNPuZhvIzCkhOCw";
export const EE_BROADBAND_CONTENT = "2vzqZIjmyS6cBHp5eiuyRG";
export const NOW_BROADBAND_IMAGE = "2PBtUXyRbO9sY48PQnCdCh";
export const NOW_BROADBAND_CONTENT = "4yoGBN2c2Otc5qRQMyXNGS";

// Articles
export const ABOUT_BT_BROADBAND = "4mIrIVuLucZK07MTcRdLr9";
export const ABOUT_TALKTALK_BROADBAND = "2ucLRTdM9PVpqfGrcto7nv";
export const ABOUT_SKY_BROADBAND = "2xjj75IcSCcKXIDgxD83sd";
export const ABOUT_PLUSNET_BROADBAND = "5Y7hLMmmuXlG3xkquUOlLa";
export const ABOUT_VIRGIN_MEDIA_BROADBAND = "1bZquc7R6uMleeJQKqzeUR";
export const ABOUT_VODAFONE_BROADBAND = "8dcUChjEli2JneFcLufmJ";
export const ABOUT_EE_BROADBAND = "15TtbIz8FR6vFfZHxnPveU";
export const ABOUT_NOW_BROADBAND = "3acl7uDBmAUfs0Or9FfZcS";
export const ABOUT_FIBRE_BROADBAND = "6I8iJt0uiVdlYdTuaLcrG8";
export const ABOUT_WIRELESS_BROADBAND = "3mdku6LReXakLDYN3I51Di";
export const ABOUT_BROADBAND_AND_HOME_PHONE = "6oPQ4HoHY9wE65NZvqw5JG";
export const ABOUT_CHEAP_BROADBAND = "4zbRQpQx97x0FJdSKXEZAq";
export const ABOUT_BROADBAND_TV = "7wsCy9lrHcqzlPZniyY78c";
export const ABOUT_BROADBAND_DEALS = "7KbN02y89hdrGEk5UynSUp";
export const ABOUT_TWELVE_MONTH_BROADBAND = "599Ybc8ioaPTw3ZRNpScuw";
export const ABOUT_BROADBAND_WITH_GIFTS = "5n6EQXD5JQVgVjUzNSPuxv";

// Tags
export const BROADBAND_GUIDES_TAG = "broadbandGuides";
export const BROADBAND_PROVIDERS_TAG = "broadbandProviders";
export const SETTING_UP_BROADBAND_TAG = "installingBroadband";
export const BROADBAND_BASICS_TAG = "broadbandBasics";
export const SWITCHING_BROADBAND_TAG = "switchingBroadband";
export const GAMING_BROADBAND_TAG = "gamingBroadband";

//Page SEO
export const HOMEPAGE_SEO = "61ppYv2XE9c6R2glpuvaZs";
export const BROADBAND_COMPARISON_SEO = "DBQdX7GUCygFOKDvZn5FB";
export const FIBRE_BROADBAND_SEO = "5WTgIavIlMJSt6WkE2uYwz";
export const WIRELESS_BROADBAND_SEO = "4x5xYw5Q7RVR0tAJpnwCoj";
export const CHEAP_BROADBAND_SEO = "bLAQtAFuWwkkYQYWsodlw";
export const BROADBAND_HOME_PHONE_SEO = "3WyRu3AxS4eQqmawdf2OYt";
export const BT_BROADBAND_SEO = "2rn4mmVYyDMa1auH0tUzc5";
export const TALKTALK_BROADBAND_SEO = "6V5f33tlv6SJU2Oyr2LK6h";
export const SKY_BROADBAND_SEO = "52u2yTpLR2nGGE5TPqAypO";
export const PLUSNET_BROADBAND_SEO = "3abTxTXRRQaCKwidWLnWHu";
export const VIRGIN_MEDIA_BROADBAND_SEO = "6pTj8DvsVxxfufpliwsE8X";
export const VODAFONE_BROADBAND_SEO = "7ixoTkpwkyOfEMQFEoyvpK";
export const EE_BROADBAND_SEO = "3Lof6P2CTY4zQXiE3cWDWw";
export const NOW_BROADBAND_SEO = "710H89QybyeYDE5tH5r2qd";
export const BROADBAND_GUIDES_SEO = "12ArN5wFRtnPxl0w40hUqi";
export const BROADBAND_AND_TV_SEO = "4Ymg66cEiucP7qoOxY8ii3";
export const ENERGY_SEO = "7qlXeYL2iJFAiSHjFSbX4P";
export const MOBILE_SEO = "2D9aoSL97qSkmlEEaiaykV";
export const CONTACT_US_SEO = "3hC4ZmM2XEFQLgcvl8uSFu";
export const ABOUT_US_SEO = "1k2HA3ev8DvMf7axyg0kFp";
export const COMPLAINTS_SEO = "7jwhC2LUzG7gShGlymbKj1";
export const PRIVACY_POLICY_SEO = "1Syfb9vd4rwUf1r7YWnp1M";
export const COOKIE_POLICY_SEO = "zwGmirdC7vXw7w8HYS7Yw";
export const TERMS_AND_CONDITIONS_SEO = "2aTuJnpqPjCveCJeqOlnze";
export const TWELVE_MONTH_BROADBAND_SEO = "68O5a95bUQp14UsfLy7KAM";
export const BROADBAND_FREE_GIFTS_SEO = "5mbUmo8GGzDoQr5HKuAlfw";

// Mobile Comparison Headers
export const MOBILE_COMPARISON_HEADER_CONTENT = "2SbQ5qReb3c7JeihnEhBVa";
export const MOBILE_COMPARISON_NO_UPFRONT_COST = "1tYqP5Y1Cb9MYyehJuSmz2";
export const SAMSUNG_MOBILE_DEALS_HEADER = "5plqu6EhisVycY2SJDK6fY";
export const IPHONE_MOBILE_DEALS_HEADER = "6CHOs9ux1oPPZ9bw0yW37O";
export const SIM_ONLY_MOBILE_DEALS_HEADER = "2Djuc2tkLRSvo8P8kYw1yZ";
export const UNLIMITED_DATA_SIM_ONLY_HEADER = "6XOI0qozkdEM5akeN22NIk";
export const FIVE_G_SIM_ONLY_HEADER = "6t8HVs7oiiCmNh89zxwAFO";
export const THIRTY_DAY_SIM_ONLY_HEADER = "4r5GXdNLytF29NA6Kx3F7B";
export const TWELVE_MONTH_SIM_ONLY_HEADER = "4S12obzeCryX7TlAw2wS4V";
export const IPHONE_14_DEALS_HEADER = "4uRAuAOOdfpkgjKbpxHilu";
export const IPHONE_14_PRO_DEALS_HEADER = "3fqs2TFWODQ34mr51dC42s";
export const IPHONE_14_PRO_MAX_DEALS_HEADER = "4cVY9KfTckpBYX9ht0Lz8T";
export const SAMSUNG_GALAXY_S23_DEALS_HEADER = "56Pou9MW0Q2k5e3hPccrZ1";
export const SAMSUNG_GALAXY_S22_DEALS_HEADER = "KGqXe1SLKmwJoMAruuK3N";
export const SAMSUNG_Z_FOLD_4_DEALS_HEADER = "6ZgEgstLC7NHJRVP8T2Z0x";
export const SAMSUNG_Z_FLIP_4_DEALS_HEADER = "1R9ksKDVebULbJe7XPKMZi";
export const SAMSUNG_GALAXY_S23_PLUS_DEALS_HEADER = "5NJ78QVlz1CX8DWSheCuy8";
export const SAMSUNG_GALAXY_S23_ULTRA_DEALS_HEADER = "PUgx2HJBkStvtK2Kl3TLc";

//Mobile Comparison Articles
export const ABOUT_MOBILE_DEALS = "3RK4CWVyVOP4DIXvpjbXFK";
export const ABOUT_MOBILE_DEALS_NO_UPFRONT_COST = "5CJXGZzZSdFUEXvCw0b81T";
export const ABOUT_SAMSUNG_MOBILE_DEALS = "3muHtqErp7dHxFIJhZc8au";
export const ABOUT_IPHONE_MOBILE_DEALS = "5aocVO50Bk4xqFwArM6nvD";
export const ABOUT_SIM_ONLY_MOBILE_DEALS = "5lNu1I8kJuKY1Pnt6DgJi8";
export const ABOUT_UNLIMITED_DATA_SIM_ONLY = "4fWF0WN8cEOGtbA3RklfwP";
export const ABOUT_FIVE_G_SIM_ONLY = "5dAJlgQW31pJ916uxlgSbF";
export const ABOUT_THIRTY_DAY_SIM_ONLY = "535TI0Rp11uR7yGx4KA0Xt";
export const ABOUT_TWELVE_MONTH_SIM_ONLY = "66Yq9OwwbYe2TDOAaRZ940";
export const ABOUT_IPHONE_14_MOBILE_DEALS = "5cIkSRycBPwcCi2qOitdej";
export const ABOUT_IPHONE_14_PRO_MOBILE_DEALS = "5il5qTDmsnYTLVFyJ0UZjU";
export const ABOUT_IPHONE_14_PRO_MAX_MOBILE_DEALS = "5WTIi8jlvU5OZrUxsXocqv";
export const SAMSUNG_GALAXY_S23_MOBILE_DEALS = "3Z7XeNfEpKS5l8B9LccFfU";
export const SAMSUNG_GALAXY_S22_MOBILE_DEALS = "4pzpN4NWEwzWt1KSEM5kzM";
export const SAMSUNG__Z_FOLD_4_DEALS = "3rNyzqRqSZbX4IUQkK1PxO";
export const SAMSUNG__Z_FLIP_4_DEALS = "2ZMZbDTAZ5mRhS1brhAYge";
export const SAMSUNG_GALAXY_S23_PLUS_MOBILE_DEALS = "7uM6d2NJBuhKiIQGwJv3gJ";
export const SAMSUNG_GALAXY_S23_ULTRA_MOBILE_DEALS = "6rPoXTPeHzJ8QLFCP9DPbX";

//Mobile Page SEO
export const MOBILE_NO_UPFRONT_COST_SEO = "47np2P82NFseFSPCDiGjAd";
export const MOBILE_COMPARISON_SEO = "3pIF6b3QhAxoTESK87JO0z";
export const SAMSUNG_MOBILE_DEALS_SEO = "5dPeMH2OeikEXvb41IXdMm";
export const IPHONE_MOBILE_DEALS_SEO = "72t4AUkAu9s2HG9jhTfp1L";
export const SIM_ONLY_DEALS_SEO = "3CCVqasXPe7lXh16WPDUhj";
export const UNLIMITED_DATA_SIM_ONLY_SEO = "3CWmBDb0h7qEh4sjvfoc1o";
export const FIVE_G_SIM_ONLY_SEO = "4q1K2uRWn7liRjDPzcbqpo";
export const THIRTY_DAY_SIM_ONLY_SEO = "2GiCxyJmXW5aTyi2zNYQ7D";
export const TWELVE_MONTH_SIM_ONLY_SEO = "5C1v5FavX5p2FI0FHXVZ89";
export const IPHONE_14_DEALS_SEO = "1FF9HYKhK1mPTqO5kFDvr7";
export const IPHONE_14_PRO_DEALS_SEO = "LN04owHK4jN6O4JbNU6yH";
export const IPHONE_14_PRO_MAX_DEALS_SEO = "1w6pL3CILDBYYx3vCwvdu2";
export const SAMSUNG_GALAXY_S23_DEALS_SEO = "3PbrLAh46bAmlrcVnPSgrX";
export const SAMSUNG_GALAXY_S22_DEALS_SEO = "8A1KawwhMxK7kUEQM7sTn";
export const SAMSUNG_Z_FOLD_4_DEALS_SEO = "4OB0CwFTtF2O6vXER1KnFL";
export const SAMSUNG_Z_FLIP_4_DEALS_SEO = "18Na1tFY5itGkwz1oi0UhS";
export const SAMSUNG_GALAXY_S23_PLUS_DEALS_SEO = "6Zv1KpNpehiPg43u53XEZ9";
export const SAMSUNG_GALAXY_S23_ULTRA_DEALS_SEO = "3OijwPAc6NHvZV1pPPypu4";

//Insurance SEO

export const INSURANCE_LANDING_PAGE_SEO = "5vl9jukm4R3BVeCprY5aJr";
export const CAR_INSURANCE_SEO = "4I2MMd9nUiylIstqbZUXle";
export const HOME_INSURANCE_SEO = "NuptXU58P4xwIqJzAj5Uh";
export const VAN_INSURANCE_SEO = "3RWIY8tYLBzBXYgdpVOlbw";
export const TRAVEL_INSURANCE_SEO = "5obagu2JCNNAsWdb3kEFaw";
export const PET_INSURANCE_SEO = "8H1pfDeAWULGV4pzRtBLd";
export const BICYCLE_INSURANCE_SEO = "1DqRFzZ2JxIRzBydov1fgU";

export const INSURANCE_PROVIDERS = "7tDgYDzcdKvvwHeapWobAW";
export const HOME_INSURANCE_PROVIDERS = "RmTttDcMpuPLiGnsvyLCE";
export const BICYCLE_INSURANCE_PROVIDERS = "3AEpFsCEDRtErDjvWnFBXe";
export const VAN_INSURANCE_PROVIDERS = "2tRdWL3Gt2wSFz0I9zOZFY";
export const PET_INSURANCE_PROVIDERS = "kTXCu6qo8G9zOGLytLKBE";
export const TRAVEL_INSURANCE_PROVIDERS = "5jGVWgsBoRujxd8vZUbqnc";

export const INSURANCE_FAQS = "5NKLVOoAQdHwy4PZH9GKtw";
export const CAR_INSURANCE_FAQS = "hamiro5a6eadk7HH6S0hZ";
export const HOME_INSURANCE_FAQS = "4P3bxGKoeECVA5hEkoxZzU";
export const VAN_INSURANCE_FAQS = "4fe5zzK3piiexSIaGKht12";
export const BICYCLE_INSURANCE_FAQS = "7IaZWLKJrddHLRaEriq53Z";
export const PET_INSURANCE_FAQS = "4csdmFNMgGZH3ZECv5240F";
export const TRAVEL_INSURANCE_FAQS = "yh7EzN9rByKyYH9G8fhZ7";

export const CAR_INSURANCE_HEADER_IMAGE = "5gxMzEPmuUuPkIY3xkeG5q";
export const HOUSE_INSURANCE_HEADER_IMAGE = "5ZxVtviboCozLaUgFB6R1m";
export const VAN_INSURANCE_HEADER_IMAGE = "345JcRwUOKhYvmEOpIJvYv";
export const BICYCLE_INSURANCE_HEADER_IMAGE = "7dTnXtjOwdqGcbC7XGJEuR";
export const PET_INSURANCE_HEADER_IMAGE = "iTEspqCSgbcbr76Kf62S0";
export const TRAVEL_INSURANCE_HEADER_IMAGE = "jdPhWg5bvmKLpi2szUorO";

//Energy Providers

export const ENERGY_PROVIDERS = "3OsVLDP0Xiu4lTHYkq54fe";

//Solar

export const SOLAR_FAQS = "IlpHLxRfFXF7x034g9n1v";

//  Validation Regexs

export const postcodeRegex =
	/^(?:GIR ?0AA|(?:(?:AB|AL|B|BA|BB|BD|BF|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(?:\d[\dA-Z]? ?\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\d{1,4})$/i;
